import { render, staticRenderFns } from "./SelectVenue.vue?vue&type=template&id=a1990e10&scoped=true&"
import script from "./SelectVenue.vue?vue&type=script&lang=js&"
export * from "./SelectVenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1990e10",
  null
  
)

export default component.exports